
import { ML_SCAN } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state == 'undefined') {
        state = [];
    }

    switch (action.type) {
        case ML_SCAN.GET.INITIATE:
            return {isFetching: true};
        case ML_SCAN.GET.SUCCESS:
            return {isFetching: false, data: action.payload};
        case ML_SCAN.GET.ERROR:
            return {isFetching: false, data: action.payload};
        default:
            return state;
    }
};